module.exports = __webpack_public_path__ + "img/icon6.df97f4b3.png";